import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { FundType, FundTypeMap } from '../models/fund-type.enum';

export const prospectusTabResolver: ResolveFn<FundType | string> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  if (!route.queryParamMap.has('fundtype')) {
    if (!route.queryParamMap.has('family')) {
      return null;
    } else {
      const fundFamilyParam = route.queryParamMap.get('family').toUpperCase();
      return fundFamilyParam || null;
    }
  }
  const fundTypeParam = route.queryParamMap.get('fundtype').toUpperCase();
  return FundTypeMap.has(fundTypeParam) ? FundTypeMap.get(fundTypeParam) : null;
};
